(function () {
  if (typeof IntersectionObserver === 'undefined') return;

  const SELECTOR = '.s-motion';
  const ENTER_CLASS = 'enter';
  const EXIT_CLASS = 'exit';

  const reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function setInitialStates(els) {
    els.forEach((el) => {
      if (el.classList.contains(ENTER_CLASS)) return;
      if (reduceMotion) {
        el.classList.add(ENTER_CLASS);
        return;
      }
      const once = el.dataset.sMotionOnce !== 'false';
      if (once) {
        el.classList.remove(EXIT_CLASS);
      }
    });
  }

  function handleEntries(entries, observer) {
    entries.forEach((entry) => {
      const el = entry.target;
      const once = el.dataset.sMotionOnce !== 'false';
      if (reduceMotion) {
        el.classList.add(ENTER_CLASS);
        el.classList.remove(EXIT_CLASS);
        if (once) observer.unobserve(el);
        return;
      }
      if (entry.isIntersecting) {
        el.classList.remove(EXIT_CLASS);
        el.classList.add(ENTER_CLASS);
        if (once) observer.unobserve(el);
      } else {
        if (!once) {
          el.classList.remove(ENTER_CLASS);
          el.classList.add(EXIT_CLASS);
        }
      }
    });
  }

  let observer = null;

  function ensureObserver() {
    if (observer) return observer;
    observer = new IntersectionObserver(handleEntries, {
      root: null,
      rootMargin: '0px 0px -10% 0px',
      threshold: 0.08
    });
    return observer;
  }

  function observe(scope) {
    if (!scope) return;
    const root = scope.matches && scope.matches(SELECTOR) ? [scope] : [];
    const descendants = scope.querySelectorAll ? Array.from(scope.querySelectorAll(SELECTOR)) : [];
    const targets = root.concat(descendants);
    if (!targets.length) return;
    setInitialStates(targets);
    const obs = ensureObserver();
    targets.forEach((el) => obs.observe(el));
  }

  function boot() {
    observe(document.documentElement);
    if (window.MutationObserver) {
      const mo = new MutationObserver((mutations) => {
        mutations.forEach((m) => {
          m.addedNodes.forEach((node) => {
            if (node.nodeType === 1) observe(node);
          });
        });
      });
      mo.observe(document.body, { childList: true, subtree: true });
    }
    if (window.Shopify && Shopify.designMode) {
      try {
        window.addEventListener('shopify:section:load', (e) => {
          if (e.target) observe(e.target);
        });
      } catch (e) {}
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();
